import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import cn from "classnames";
import { Aviation } from "../../../../../services";
import CustomButton from "../../../../custom/custom-button/CustomButton";
import ConfirmActionModal from "../../../../orders-new/order-info-expeditor/components/ConfirmActionModal/ConfirmActionModal";
import style from "../../../../orders-new/order-info-expeditor/components/tabs/ActionsTab.module.scss";

const formatPrice = (value, currency = "KZT") => {
  if (value === null || value === undefined) return "—";
  const formatted = Number(value).toLocaleString("ru-RU").replace(/,/g, " ");
  return `${formatted} ${currency === "KZT" ? "₸" : currency}`;
};

const AviationExpeditorAssignedAction = ({ order, fetchOrderData, onForceUpdate }) => {
  const { t } = useTranslation();
  const [decision, setDecision] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const isAccepting = decision === "confirmed";

  const handleConfirm = async () => {
    if (!order?.id || !decision || isLoading) return;

    try {
      setIsLoading(true);
      await Aviation.updateStatus(order.id, decision);
      toast.success(t(`orderInfoExpeditor.actions.${isAccepting ? "orderAccepted" : "orderRejected"}`));
      setDecision(null);
      await fetchOrderData?.();
      onForceUpdate?.();
    } catch {
      toast.error(t("orderInfo.genericError"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={cn(style.card, style.card_compact)}>
      <div className={style.topbar}>
        <span className={style.topbar_title}>{t("orderInfoExpeditor.actions.partnerAssignedTrip")}</span>
        <span className={style.topbar_meta}>{t("orderInfoExpeditor.actions.amountFixed")}</span>
      </div>
      <div className={style.amount_row}>
        <span className={style.amount_label}>{t("orderInfoExpeditor.actions.amount")}</span>
        <span className={style.amount_value}>{formatPrice(order?.price, order?.currency)}</span>
      </div>
      <div className={style.actions_row}>
        <div className={style.actions_row_primary}>
          <CustomButton
            text={t("orderInfo.orderDecision.acceptButton")}
            isNavy
            isFall
            onClick={() => setDecision("confirmed")}
            isLoading={isLoading}
            disabled={isLoading}
          />
        </div>
        <div className={style.actions_row_secondary}>
          <CustomButton
            text={t("orderInfo.orderDecision.rejectButton")}
            isNavy
            isWhite
            onClick={() => setDecision("expeditorRejected")}
            disabled={isLoading}
            style={{ width: "100%" }}
          />
        </div>
      </div>

      <ConfirmActionModal
        isOpen={decision !== null}
        title={t(
          `orderInfoExpeditor.actions.${isAccepting ? "acceptOrderConfirmTitle" : "rejectOrderConfirmTitle"}`,
        )}
        message={t(`orderInfoExpeditor.actions.${isAccepting ? "acceptTripMessage" : "rejectTripMessage"}`)}
        confirmText={t("common.yes")}
        cancelText={t("common.no")}
        onConfirm={handleConfirm}
        onCancel={() => {
          if (!isLoading) setDecision(null);
        }}
        isLoading={isLoading}
      />
    </div>
  );
};

export default AviationExpeditorAssignedAction;
